import React, { useCallback, useState } from 'react';
import Img from '../../../../../../components/Img';
import Slider from '../../../../../../components/utils/Slider/Slider';
import './WidgetPreviewEventSwipeLayout.scss';

const WidgetPreviewEventSwipeLayout = (props) => {
  const { list } = props;

  /**
   *  함수형 컴포넌트에서 사용될 state 초기화
   */
  const [swipeIndex, setSwipeIndex] = useState(0);

  /**
   *  slider before onchange event 가 발생을 할 때마다
   *  swipeIndex 를 업데이트 함
   */
  const onChange = useCallback((oldIndex, newIndex) => {
    setSwipeIndex(newIndex);
  }, []);

  return (
    <div className="widget-event-swipe-layout">
      <Slider
        list={list}
        arrows={false}
        dots={false}
        beforeChange={onChange}
        infinite={false}
        item={(eventItem) => <Img clickAble={false} src={eventItem.url} />}
      />

      <div className="number-indicator-wrap">
        <span className="current">{swipeIndex + 1}/</span>
        <span className="entire">{list.length}</span>
      </div>
    </div>
  );
};

export default WidgetPreviewEventSwipeLayout;
